import { DateTime } from 'luxon';
import { DateZone, MarketHours } from '@oai-frontend-monorepo/types';
import { mapHolidays } from '../market-information/mapHolidays';

export const getMaxExpiryForRange = (range = 1, marketHours: MarketHours) => {
  let day = DateTime.utc().setZone(DateZone.New_York);

  let currentCount = 1;
  let _range = range;

  const holidays = mapHolidays(marketHours);

  // not sure if this will break on weekends
  if (range === 1 && (day.hour < 9 || (day.hour === 9 && day.minute < 30))) {
    return day.setZone(DateZone.New_York).minus({ day: 1 }).toFormat('yyMMdd');
  }

  // not sure if this will break on weekends, this is to account for no history premarket
  if (day.hour < 9 || (day.hour === 9 && day.minute < 30)) {
    _range -= 1;
  }

  if (_range === 1) {
    return day.setZone(DateZone.New_York).toFormat('yyMMdd');
  }

  if (range === 30) {
    return day.setZone(DateZone.New_York).plus({ month: 1 }).toFormat('yyMMdd');
  }

  if (_range > 5) {
    return day
      .setZone(DateZone.New_York)
      .plus({ days: _range })
      .toFormat('yyMMdd');
  }

  while (currentCount < _range || day.weekday > 5) {
    day = day.plus({ days: 1 });

    const isWeekend = day.weekday > 5;

    if (!isWeekend && !holidays[day.toFormat('yyyy-MM-dd')]) {
      currentCount += 1;
    }
  }

  return day.setZone(DateZone.New_York).toFormat('yyMMdd');
};
